import React from 'react';
import { Link } from 'react-router-dom';
// import { Package } from 'lucide-react';

const ProductsPreview = ({ products }) => {
	const recentProducts = products.slice(0, 4);

	return (
		<div className='dashboard-panel'>
			<div className='dashboard-panel__header'>
				<div>
					<h3 className='dashboard-panel__title'>Products</h3>
					<p className='dashboard-panel__subtitle'>Your recent listings</p>
				</div>

				<Link to='/products' className='dashboard-panel__link'>
					View all
				</Link>
			</div>

			{recentProducts.length > 0 ? (
				<div className='dashboard-thumb-grid'>
					{recentProducts.map((product) => (
						<div className='dashboard-thumb-card' key={product._id}>
							<div className='dashboard-thumb-card__image-wrap'>
								<img
									src={product.image?.[0]}
									alt={product.title}
									className='dashboard-thumb-card__image'
								/>
							</div>

							<div className='dashboard-thumb-card__body'>
								<h4>{product.title}</h4>
								<p>{product.description || 'No description available'}</p>
								<span>CD$ {product.price}</span>
							</div>
						</div>
					))}
				</div>
			) : (
				<div className='dashboard-empty'>
					No products yet. Add your first product to grow your store.
				</div>
			)}
		</div>
	);
};

export default ProductsPreview;
